
export const environment = {"production":true,"version":"0.0.28"};



// WEBPACK FOOTER //
// ./src/environments/environment.prod.ts